<nav class="u-m-b-16">
  <ul class="breadcrumbs">
    <li>Job Schedules</li>
  </ul>
</nav>
<header class="u-m-b-40">
  <div class="row">
    <div class="columns">
      <h1 class="typography--display1">Job Schedules</h1>
    </div>
  </div>
</header>
<main role="main u-m-t-20">
  <div class="row">
    <div class="columns">
      <div class="card spinner-section" [class.spinner-section--is-active]="vm.loadingCharges">
        <div class="spinner-section__icon"></div>
        <opus-jobs-header [opusJobs$]="opusJobs$" (criteriaChangeEvent)="onCriteriaChange($event)"></opus-jobs-header>
        <div class="columns">
          <span></span>
        </div>
        <div class="columns shrink">
          <div class="columns" *ngIf="(opusJobs$ | async)?.length > 0">
            <div class="btn-group">
              <div *ngIf="!isEditing">
                <button
                  class="btn btn--hollow btn--tiny btn--edit btn-group__btn"
                  (click)="onToggleEdit()"
                  opusAuthorize="OpusJob.EditDetails"
                  [opusRelationshipManagerRoles]="['aa_OPUS-MAA_Admin']"
                  [opusRelationshipManagerEmail]="relationshipManagerEmail"
                >
                  Edit
                </button>
              </div>
              <div *ngIf="isEditing">
                <button class="btn btn--tiny btn--edit btn-group__btn" (click)="onSaveChanges()">Save Changes</button>
                <button class="btn btn--hollow btn--tiny btn-group__btn" (click)="onToggleEdit()">Cancel Edit</button>
              </div>
            </div>
          </div>
        </div>
        <opus-jobs-table #editor [criteria]="criteria" [opusJobs$]="opusJobs$" [isEditing]="isEditing"></opus-jobs-table>
      </div>
    </div>
  </div>
</main>
